import createSharedReactContext from 'create-shared-react-context';

const LocaleContext = createSharedReactContext({
  locale: '',
  lang: ''
}, 'dlsLocaleContext');
var LocaleContext$1 = LocaleContext;

export { LocaleContext$1 as default };
